/* eslint-disable @typescript-eslint/no-explicit-any */

import { FormaliteDocument, useFormaliteService } from '@europrocurement/l2d-domain';
import {
    TypeDeDocumentJsonldTypedocumentCreate,
    TypeDeDocumentJsonldTypedocumentUpdate,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { useApiRequest } from '@europrocurement/l2d-hooks';

const toNullableString = (value: unknown): string | null => {
    if (value === undefined || value === null || value === '') {
        return null;
    }

    return value as string;
};

const useDocumentTypeFormHandler = () => {
    const { typeDocApi } = useFormaliteService();
    const { request, requestState } = useApiRequest();

    const handleCreateForm = async (formData: { [key: string]: any }) =>
        new Promise<{ data: { id: number } }>((resolve) => {
            const { libelle, name, type, help, libelleDF, signable, typageAuto, vide, statut } =
                formData;

            const payload: TypeDeDocumentJsonldTypedocumentCreate = {
                libelle: toNullableString(libelle),
                name: toNullableString(name),
                type: type?.value ?? null,
                help: toNullableString(help),
                libelleDF: toNullableString(libelleDF),
                signable: Boolean(signable?.value),
                typageAuto: Boolean(typageAuto?.value),
                vide: Boolean(vide?.value),
                statut: statut?.value ?? null,
                domaine: '/formalite/domaines/3',
            };

            request(
                typeDocApi.apiTypesDocumentsPost({
                    typeDeDocumentJsonldTypedocumentCreate: payload,
                }),
                {
                    successCallback: (response) =>
                        resolve(response as unknown as { data: { id: number } }),
                },
            );
        });

    const handleEditForm = async (
        documentType: FormaliteDocument,
        formData: { [key: string]: any },
    ) =>
        new Promise((resolve) => {
            const { libelle, name, type, help, libelleDF, vide, statut } = formData;

            const payload: TypeDeDocumentJsonldTypedocumentUpdate = {
                libelle: toNullableString(libelle),
                name: toNullableString(name),
                type: type?.value ?? null,
                help: toNullableString(help),
                libelleDF: toNullableString(libelleDF),
                vide: Boolean(vide?.value),
                statut: statut?.value ?? null,
            };

            request(
                typeDocApi.apiTypesDocumentsIdPut({
                    id: String(documentType.id),
                    typeDeDocumentJsonldTypedocumentUpdate: payload,
                }),
                {
                    successCallback: resolve,
                },
            );
        });

    const handleDeleteForm = async (documentType: FormaliteDocument) =>
        new Promise((resolve) => {
            request(
                typeDocApi.apiTypesDocumentsIdDelete({
                    id: String(documentType.id),
                }),
                {
                    successCallback: resolve,
                },
            );
        });

    return {
        handleCreateForm,
        handleEditForm,
        handleDeleteForm,
        requestState,
    };
};

export default useDocumentTypeFormHandler;
